import { FC, useMemo } from 'react';
import { useAuthentication } from '@connect-x-app/hybrid-state';
import { AdminConfigPermissions } from '@connect-x-app/shared-domain-models';

import { QuickRepliesTable } from '../../../shared/components/QuickRepliesTable';
import { useQuickRepliesContentTable } from './hooks/useQuickRepliesContentTable';

import './AdminQuickReplies.scss';

export const AdminQuickReplies: FC = () => {
  const { hasPermission } = useAuthentication();

  const canDelete = useMemo(() => {
    return hasPermission(AdminConfigPermissions.DELETE);
  }, [hasPermission]);

  const canUpdate = useMemo(() => {
    return hasPermission(AdminConfigPermissions.WRITE);
  }, [hasPermission]);

  const {
    createQuickReply,
    deleteQuickReplies,
    isLoading,
    isLoadingCreateQuickReply,
    isLoadingDeleteQuickReplies,
    isLoadingUpdateQuickReply,
    itemsToDelete: selectedItems,
    quickReplies,
    table,
    updateQuickReply,
  } = useQuickRepliesContentTable({
    renderCheckbox: canDelete,
  });

  return (
    <QuickRepliesTable
      deletePermission={canDelete}
      isLoading={isLoading}
      isLoadingDeleteQuickReplies={isLoadingDeleteQuickReplies}
      isLoadingUpdateQuickReplies={isLoadingCreateQuickReply || isLoadingUpdateQuickReply}
      onCreateQuickReply={quickReply => createQuickReply(quickReply)}
      onDeleteQuickReplies={deleteQuickReplies}
      onUpdateQuickReply={quickReply => updateQuickReply(quickReply)}
      quickReplies={quickReplies}
      selectedItems={selectedItems ?? []}
      table={table}
      updatePermission={canUpdate}
    />
  );
};
